module.exports = __webpack_public_path__ + "img/saiten.0064216b.png";